<template>
    <b-overlay :show="saveLoading" spinner-small spinner-variant="secondary">
        <click-edit :default-value="`ID:${id}`"
                    :value-label="`ID:${id}→Code: `"
                    :value.sync="dictCode.name" @inputBlur="doSave"/>
    </b-overlay>
</template>

<script>
import {DICT_TYPE} from "@/plugins/configure-query-helper.js"
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ClickEdit from "@/components/common/inputs/ClickEdit.vue";

export default {
    name: "IdRecode",
    components: {ClickEdit},
    mixins: [emCommonUtilMixin],
    props: {
        id: Number,
        service: String,
        codeConfig: Array,
    },
    data() {
        return {
            dictCode: {},
            saveLoading: false,
        }
    },
    watch: {
        id: {
            handler() {
                this.queryCode();
            },
            immediate: true
        },
        codeConfig: {
            handler() {
                this.queryCode();
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        getCode(config) {
            let temp = this.service + ":" + this.id;
            let got = false;
            if (config) {
                for (let item of config) {
                    if (item.value === temp) {
                        this.dictCode = item;
                        got = true;
                        break;
                    }
                }
            }
            if (!got) {
                this.dictCode = {value: temp};
            }
        },
        queryCode() {
            if (this.id && this.service) {
                if (this.codeConfig) {
                    this.getCode(this.codeConfig);
                } else {
                    this.$store.dispatch('api/get', {
                        url: `${this._baseUrl('emDictData')}simple/${DICT_TYPE}/query`
                    }).then(res => {
                        this.getCode(res);
                    });
                }
            }
        },
        doSave() {
            if (this.dictCode && this.dictCode.name) {
                this.saveLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${this._baseUrl('emDictData')}simple/${DICT_TYPE}/edit`,
                    data: {
                        editRows: [this.dictCode]
                    }
                }).then(() => {
                    this.queryCode();
                }).finally(() => this.saveLoading = false);
            }
        },
    }
}
</script>

<style scoped>

</style>
